<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="connect-eld-container flex justify-center px-4">
      <div class="flex flex-col items-start rounded bg-white p-6">
        <h3 class="mb-4 text-2xl text-dark-blue">Uh oh.</h3>
        <p class="mb-4 text-left text-body-color">
          Your ELD isn't connected to Highway. Connect your ELD to keep viewing
          broker profiles.
        </p>

        <div class="flex w-full">
          <button-main @click="connectEld"> Connect my ELD </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'UserRequestModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    type: String,
  },
  emits: ['connect-eld'],
  methods: {
    connectEld() {
      this.$emit('connect-eld');
    },
  },
};
</script>

<style scoped>
.connect-eld-container {
  width: 500px;
}

@media screen and (max-width: 499px) {
  .connect-eld-container {
    width: 320px;
  }
  h3 {
    @apply text-xl;
  }
}
</style>
